/* eslint-disable */
import React, { useState } from "react";

import { Grid, Typography } from "@mui/material";
import {
  LocationOn as LocationOnIcon,
  QueryBuilder as QueryBuilderIcon,
  Launch as LaunchIcon,
  LocalPhone as LocalPhoneIcon,
  ArrowBack as ArrowBackIcon,
  LocalOfferOutlined as LocalOfferOutlinedIcon,
} from "@mui/icons-material";

import { useTranslation } from "react-i18next";

import {
  OrderProps,
  OrderUpdateActions,
} from "store/modules/Orders/types.store";

import { formatByText, formatProductNameAndDescription } from "utils";
import { formatStreetAddress } from "utils/formatByText";

import * as Styled from "./styles";
import { useNavigate } from "react-router-dom";
import { useOrders } from "pages/ManageOrders/useOrders";
import {
  copyDivToClipboard,
  formatPhoneByText,
  totalPrices,
  voucherFunction,
} from "utils/formatByText";
import {
  EOrderStatusFinally,
  EStatusPayments,
} from "enums/options/orders";
import { toast } from "react-toastify";
import DivCopyComponent from "./divCopyComponent";
import TimeLine from "./TimeLine";
import OrderDriverSection from "pages/ManageOrders/components/CardOrderDetails/OrderDriverSection";
import {
  addHoursToDate,
  formatDateToDDMMYYYY,
  formatDateToHHMM,
} from "utils/dateUtils";
import { orderHasGasDoPovoItems } from "utils/gasDoPovo";

interface CardActionsProps {
  data: OrderProps;
  handleOrderUpdate?: (
    type: OrderUpdateActions,
    id: string,
    dealerId: string,
  ) => void;
  currentTab?: string;
  fullHeight?: boolean;
  handleBack?: () => void;
}

const CardOrderDetails: React.FC<CardActionsProps> = ({
  data,
  handleOrderUpdate,
  currentTab,
  fullHeight,
  handleBack,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { typeOrders } = useOrders();
  const showGasDoPovoFlag = orderHasGasDoPovoItems(data?.items);

  const [scheduledOrder] = useState(true); // TODO: trocar esse dado para o real vindo com os dados do pedido
  const [scheduledOrderDate] = useState(0); // TODO: trocar esse dado para o real vindo com os dados do pedido

  const typesOfCompletedOrders = [
    EOrderStatusFinally.TIMEOUTCANCELLED,
    EOrderStatusFinally.CONSUMERCANCELLED,
    EOrderStatusFinally.DEALERCANCELLED,
    EOrderStatusFinally.DELIVERED,
  ];

  const timeLineFunction = (data: OrderProps) => {
    const timeLineFinalized = data?.timeline?.find((data) =>
      typesOfCompletedOrders?.find((status) => status === data?.description),
    );

    if (timeLineFinalized && currentTab === "3") {
      return data?.createdAt
        ? ` ${formatDateToHHMM(
            timeLineFinalized?.occurredAt || "",
          )} do dia ${formatDateToDDMMYYYY(
            timeLineFinalized?.occurredAt || "",
          )}`
        : t("undefined");
    }
    if (currentTab !== "3" && data?.createdAt) {
      return `${formatDateToHHMM(
        data?.createdAt || "",
      )} do dia ${formatDateToDDMMYYYY(data?.createdAt || "")}`;
    }

    return t("undefined");
  };

  const handleCopy = () => {
    copyDivToClipboard("order-content");
    toast("Copiado!", {
      type: "success",
    });
  };

  return (
    <Styled.Container>
      <Styled.ContentDetails
        currentTab={currentTab === "3"}
        fullHeight={fullHeight}
      >
        <Styled.ContainerArrow>
          <Styled.ButtonBack onClick={handleBack}>
            <ArrowBackIcon fontSize="small" color="inherit" />
          </Styled.ButtonBack>
        </Styled.ContainerArrow>
        <DivCopyComponent data={data} />
        <Grid container direction="column" rowGap={2}>
          <Styled.ContainerRow>
            <Typography variant="caption">ID do pedido: {data?.id}</Typography>
            <Styled.ButtonCopy onClick={handleCopy}>
              <Styled.TitleCopy>Copiar Pedido</Styled.TitleCopy>
            </Styled.ButtonCopy>
          </Styled.ContainerRow>
          <Typography variant="h6"> {data?.consumer?.name}</Typography>
          <Styled.ContainerProhone>
            <Styled.TextPhone sx={{ fontSize: "15px" }} variant="caption">
              <LocalPhoneIcon
                sx={{ marginRight: "5px", marginTop: "2px" }}
                fontSize="small"
                color="inherit"
              />

              {data?.consumer?.phone && data?.consumer?.phone?.length >= 10
                ? formatPhoneByText(
                    data?.consumer?.phone
                      ?.replace(/[^0-9]+/g, "")
                      .replace(/^[ ]*55([\s\S]+)/, "$1") || "",
                  )
                : data?.consumer?.phone
                    ?.replace(/[^0-9]+/g, "")
                    .replace(/^[ ]*55([\s\S]+)/, "$1") || ""}
            </Styled.TextPhone>
            {currentTab !== "1" && currentTab !== "3" && (
              <Styled.ButtonChat
                onClick={() =>
                  navigate(`/orders/chat`, {
                    state: { ordersInProgress: typeOrders("InProgress") },
                  })
                }
              >
                {t("viewMessage")}
              </Styled.ButtonChat>
            )}
          </Styled.ContainerProhone>
          <Styled.ContainerFlags>
            {showGasDoPovoFlag && (
              <Styled.GasDoPovoTag>Gás do Povo</Styled.GasDoPovoTag>
            )}
            {scheduledOrder && scheduledOrderDate ? (
              <Styled.ScheduledDeliveryOrder>
                <LocalOfferOutlinedIcon fontSize="small" />
                <Typography variant="subtitle2">
                  {` Agendado para hoje entre ${formatDateToHHMM(
                    scheduledOrderDate,
                  )} e ${addHoursToDate(scheduledOrderDate, 1)}`}
                </Typography>
              </Styled.ScheduledDeliveryOrder>
            ) : null}
          </Styled.ContainerFlags>
          <Grid item sm={12} md={6} xs={6} xl={6}>
            <Grid container rowGap={2}>
              <Styled.ContainerAdress>
                <Grid item sm={12} md={6} xs={6} xl={6}>
                  <Styled.Grid>
                    <LocationOnIcon fontSize="small" color="inherit" />
                    <Styled.ContainerText>
                      <Typography variant="body1" textAlign="start">
                        {formatStreetAddress(data?.delivery?.address)}
                      </Typography>

                      <Typography variant="inherit" textAlign="start">
                        {data?.delivery?.address?.district}
                      </Typography>

                      <Styled.TitleMoreInfo variant="caption">
                        Informações Adicionais:
                      </Styled.TitleMoreInfo>
                      <Typography variant="inherit">
                        {data?.delivery?.remarks}
                      </Typography>
                    </Styled.ContainerText>
                  </Styled.Grid>
                </Grid>
                <Styled.ButtonMap>
                  <Styled.Link
                    href={`http://maps.google.com?q=${data?.delivery?.address?.latitude},${data?.delivery?.address?.longitude}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    ABRIR MAPA
                  </Styled.Link>
                  <LaunchIcon fontSize="small" color="inherit" />
                </Styled.ButtonMap>
              </Styled.ContainerAdress>
            </Grid>
          </Grid>
          <Styled.ContainerAdress>
            <Grid item sm={12} md={6} xs={6} xl={6}>
              <Styled.ContainerHours>
                <QueryBuilderIcon fontSize="small" color="inherit" />
                <Styled.ContainerText>
                  <Typography variant="subtitle2" textAlign="start">
                    {currentTab !== "3" ? "Solicitado às " : "Finalizado às "}
                    {timeLineFunction(data)}
                  </Typography>
                </Styled.ContainerText>
              </Styled.ContainerHours>
            </Grid>
            <TimeLine dataOrder={data} currentTab={currentTab} />
          </Styled.ContainerAdress>

          <OrderDriverSection data={data} currentTab={currentTab} />
        </Grid>

        <Styled.ContainerProducts>
          <Typography variant="subtitle2" textAlign="start" fontWeight={400}>
            Produtos
          </Typography>
          {data?.items?.map((product) => (
            <>
              <Styled.CardProducts>
                <Styled.ContainerProductsTitle>
                  <Typography variant="subtitle2" textAlign="start">
                    {`${product.quantity} ${formatProductNameAndDescription(product.name, product.description)}`.trimEnd()}
                  </Typography>
                  <Typography variant="subtitle2" textAlign="start">
                    {formatByText.formatCurrency(Number(product.unitPrice))}
                  </Typography>
                </Styled.ContainerProductsTitle>
              </Styled.CardProducts>
            </>
          ))}

          <>
            <Styled.CardProducts>
              <Styled.ContainerProductsTitle isColor={"rgba(211,49,0,0.08)"}>
                <Styled.ContainerDiscounts>
                  <Typography variant="subtitle2" textAlign="start">
                    {t("discounts")}
                  </Typography>
                  {voucherFunction(data) && (
                    <Styled.ContainerCupom>
                      {voucherFunction(data)}
                    </Styled.ContainerCupom>
                  )}
                </Styled.ContainerDiscounts>
                <Typography variant="subtitle2" textAlign="start">
                  {formatByText.formatCurrency(
                    data?.discount ? data?.discount : "0",
                  )}
                </Typography>
              </Styled.ContainerProductsTitle>
              <Styled.ContainerProductsTitle isColor={"rgba(211,49,0,0.08)"}>
                <Styled.TitleStatus variant="subtitle2" textAlign="start">
                  {t("totalReceivable")}

                  {data?.paymentStatus === EStatusPayments.PAYED && (
                    <Styled.ContainerStatus>
                      <Typography
                        variant="h2"
                        textAlign="start"
                        color="white"
                        fontSize={15}
                      >
                        PAGO
                      </Typography>
                    </Styled.ContainerStatus>
                  )}
                </Styled.TitleStatus>
                <Typography variant="subtitle2" textAlign="start">
                  {formatByText.formatCurrency(
                    Number(
                      totalPrices(data) - (data?.discount ? data?.discount : 0),
                    ),
                  )}
                </Typography>
              </Styled.ContainerProductsTitle>
            </Styled.CardProducts>
          </>
        </Styled.ContainerProducts>

        <Styled.ContainerDocumentFiscal>
          <Typography variant="caption">CPF ou CNPJ</Typography>

          <Styled.CardProducts>
            <Styled.ContainerProductsTitle>
              <Typography variant="subtitle2" textAlign="start">
                {formatByText.cpfOrCnpjFormat(data?.fiscal?.document || "")}
              </Typography>
            </Styled.ContainerProductsTitle>
          </Styled.CardProducts>
        </Styled.ContainerDocumentFiscal>

        <Styled.ContainerFormOfPayment>
          <Typography variant="caption" textAlign="start">
            {t("FormOfPayment")}
          </Typography>
          <Typography
            variant="subtitle2"
            textAlign="start"
            sx={{
              paddingLeft: 2,
              background: "rgba(211,49,0,0.08)",
            }}
          >
            {data?.items?.length === 1 && data?.voucher?.valeGas
              ? "Vale Gás colaborador Supergasbras"
              : `
              ${data?.payment?.type ?? ""} (${
                  data?.payment.description === "Dinheiro" &&
                  data?.payment?.change > 0
                    ? `${t("money")} ${t(
                        "changeTo",
                      )} ${formatByText.formatCurrency(
                        Number(data?.payment?.change),
                      )}`
                    : data?.payment.description
                })`}
          </Typography>
        </Styled.ContainerFormOfPayment>
      </Styled.ContentDetails>
      {currentTab !== "3" && (
        <Styled.ContainerButtons>
          <Styled.ButtonRecuseOrder
            onClick={() =>
              handleOrderUpdate &&
              handleOrderUpdate(
                data?.status === "Placed" ? "deny" : "cancel",
                data?.id || "",
                data?.dealer.id || "",
              )
            }
            color="inherit"
          >
            {data?.dealerState === "New"
              ? t("refuse").toUpperCase()
              : t("cancel").toUpperCase()}
          </Styled.ButtonRecuseOrder>

          <Styled.ButtonAcceptOrder
            onClick={() =>
              handleOrderUpdate &&
              handleOrderUpdate(
                data?.dealerState === "New" ? "accept" : "finalize",
                data?.id || "",
                data?.dealer.id || "",
              )
            }
            color="error"
          >
            {data?.dealerState === "New"
              ? t("toAccept").toUpperCase()
              : t("finish").toUpperCase()}
          </Styled.ButtonAcceptOrder>
        </Styled.ContainerButtons>
      )}
    </Styled.Container>
  );
};

export default CardOrderDetails;
